import { useEffect, useState } from 'react'

import i18n, { i18nInit } from 'core/config/i18n'
import LanguageHelper from 'common/helpers/language'
import DateHelper from 'common/helpers/date'
import { User } from 'modules/auth/types'
import { Language } from 'common/types'

const useSetLanguage = (user?: User) => {
  const [isLoading, setIsLoading] = useState(true)

  const setLanguage = async (language: Language) => {
    await i18nInit(language)
    i18n.changeLanguage(language)
    setIsLoading(false)
  }

  const userLanguage = user && LanguageHelper.getUserLanguage(user)
  const language = userLanguage
  || LanguageHelper.cookieLanguage
  || LanguageHelper.navigatorLanguage
  || LanguageHelper.defaultLanguage

  useEffect(() => {
    setLanguage(language)

    DateHelper.setLocale(language)
  }, [language])

  return { isLoading }
}

export default useSetLanguage
